export default __webpack_public_path__ + "static/media/Materialize.a3cce6ad.svg";